import React from 'react';
import { Amplify } from 'aws-amplify';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { TrackJS } from 'trackjs';
import { Hub } from 'aws-amplify/utils';
import AmplifyConfig from './app/shared/config/Amplify';
import configureStore from './app/store/configureStore';
import { restoreAppRedirectFromCustomState } from './app/shared/config/amplifyAuthAdapter';
import { reportHandledError } from './app/shared/Services/trackJsErrorReporter';

Amplify.configure(AmplifyConfig);
const store = configureStore();

Hub.listen('auth', ({ payload }) => {
    if (payload.event === 'customOAuthState') {
        restoreAppRedirectFromCustomState(payload.data);
    }
});

if (AmplifyConfig.TrackJs) {
    TrackJS.install({
        ...AmplifyConfig.TrackJs,
        console: {
            ...AmplifyConfig.TrackJs.console,
            error: false,
        },
        onError: (payload, error) => {
            const message = payload?.message || error?.message || '';

            if (message.includes('plausible.io/api/event')) {
                return false;
            }

            return typeof AmplifyConfig.TrackJs.onError === 'function'
                ? AmplifyConfig.TrackJs.onError(payload, error)
                : true;
        },
    });
}
const container = document.getElementById("root");
const root = createRoot(container);

const startApplication = async () => {
    const { default: App } = await import('./App');

    root.render(
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    );
};

void startApplication().catch(error => {
    reportHandledError('application.start.failed', error, { operation: 'startApplication' });
});
